import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import listOrder from './modules/listOrder';
import listItem from './modules/listItem';
import scan from './modules/scan';
import summary from './modules/summary';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {},
	mutations: {},
	actions: {},
	modules: {
		auth,
		listOrder,
		listItem,
		scan,
		summary
	},
});
